<script lang="ts">
  import { browser } from '$app/environment';
  import { onMount } from 'svelte';

  export let height: number = 0;
  export let width: number = 0;
  export let breakpoint: string = '';

  //These are the tailwind defaults. It'd be nice to read them direct from tailwind config,
  //but that's a pain due to TS/ESM compatibility.
  const BREAKPOINTS = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
  };

  function handleViewportResize() {
    height = this.height;
    width = this.width;
    for (const [label, threshold] of Object.entries(BREAKPOINTS)) {
      if (width <= threshold) {
        breakpoint = label;
        break;
      }
    }
  }

  onMount(async () => {
    let viewport = window.visualViewport;

    viewport.addEventListener('resize', handleViewportResize);
    handleViewportResize.bind(viewport)();
  });
</script>
